




























import { Component, Vue } from 'vue-property-decorator';
import ReportCardTemplate from './ReportCardTemplate.vue';
@Component({
  components: {
    ReportCardTemplate,
  },
})
export default class PneumoniaIndexInterpretation extends Vue {}
